package stocking;
import js.html.audio.AudioContext;
import js.html.audio.AudioBuffer;
import js.html.Audio;


class AudioManager
{

	public static var instance(default, null):AudioManager = new AudioManager();

	private var scenes = new Array<Scene>();
	//private var ctx = new AudioContext( NORMAL );
	private var audioCache = new Map<String, Audio>();

	public function new()
	{
		
	}

	public function preloadBuffer( url : String, onReady : Null<Void -> Void> )
	{
		var components = url.split('.');
		var components = components[0].split('/');
		var name = components[components.length - 1];

		if( audioCache.exists(name ) )
		{
			// @todo BROKEN AS SHIT
			if( onReady != null )
				onReady();
			return;
		}

		var element = new Audio( url );
		element.preload = "auto";
		//element.load();
		if( onReady != null )
			element.onloadeddata = onReady;
		
		audioCache.set(name, element);

	}

	public function play( url : String, ?onComplete: Null<Void -> Void> ) : Null<js.html.Audio>
	{
		
		var components = url.split('.');
		var components = components[0].split('/');
		var name = components[components.length - 1];

		var snd = audioCache.get( name );
		if( snd == null )
		{
			trace("Tried to play unknown sound: " + name);
			return null;
		}
		// @todo make this better.
		snd.currentTime = 0;
		snd.play();

		if( onComplete != null )
			snd.onended = onComplete;

		return snd;
	}


}